import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import reference from "./safety-guide-reference.json";

export default function SafetyGuide() {
  const hostRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const host = hostRef.current;
    // Isolate the supplied document from dashboard element and grid styles.
    const root = host.shadowRoot || host.attachShadow({ mode: "open" });
    if (!root.querySelector('main')) {
      root.innerHTML = `<style>${reference.styles}</style><div class="guide-shell">${reference.markup}</div>`;
    }
    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const select = id => {
      tabs.forEach(tab => {
        const selected = tab.id === id;
        tab.setAttribute("aria-selected", String(selected));
        tab.tabIndex = selected ? 0 : -1;
        root.getElementById(tab.getAttribute("aria-controls")).hidden = !selected;
      });
    };
    select(location.hash === "#hot-wallets" ? "t-hot" : "t-addr");
    const changeTab = tab => {
      select(tab.id);
      navigate({ pathname: location.pathname, search: location.search, hash: tab.id === "t-hot" ? "#hot-wallets" : "#wallet-addresses" }, { replace: true });
    };
    const click = event => {
      const tab = event.target.closest('[role="tab"]');
      if (tab) changeTab(tab);
      if (event.target.closest('.support a')) {
        event.preventDefault();
        navigate("/dashboard/support-tickets");
      }
    };
    const keydown = event => {
      const tab = event.target.closest('[role="tab"]');
      if (tab && ["ArrowRight", "ArrowLeft"].includes(event.key)) {
        event.preventDefault();
        const next = tabs.find(item => item !== tab);
        next.focus();
        changeTab(next);
      }
    };
    root.addEventListener("click", click);
    root.addEventListener("keydown", keydown);
    return () => {
      root.removeEventListener("click", click);
      root.removeEventListener("keydown", keydown);
    };
  }, [location.hash, location.pathname, location.search, navigate]);

  return <div ref={hostRef} className="safety-guide-reference" />;
}
